module.exports = __webpack_public_path__ + "static/img/baomingTop.8c0210d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baomingTop.png
// module id = xDTX
// module chunks = 1